import { cx } from '@emotion/css';
import { ChatDialogue, ChatDialogueProps } from './ChatDialogue';

interface SimpleChatProps extends ChatDialogueProps {
  className?: HTMLDivElement['className'];
  contextMenu: JSX.Element | null;
}

export const SimpleChat = (props: SimpleChatProps) => {
  const { className, contextMenu, ...chatDialogueProps } = props;

  return (
    <>
      <div className={cx('flex flex-col overflow-hidden flex-1 h-full', className)}>
        <ChatDialogue {...chatDialogueProps} />
      </div>
      {contextMenu}
    </>
  );
};
